<template>
  <div class="base-tabs">
    <div class="base-tabs__tabs">
        <slot name="tabs"></slot>
    </div>
    <div class="base-tabs__content">
        <slot name="content"></slot>
    </div>
  </div>
</template>

<style lang="scss">
.base-tabs {
    border: 1px solid var(--color-grey-200);
    box-shadow: 0 0 1.2rem rgba(0, 0, 0, 0.07);
}

.base-tabs__tabs {
    display: flex;
    background-color: var(--color-grey-100);
}

.base-tabs__tabs > * {
    padding: var(--measure-m);
}

.base-tabs__tabs > .router-link-active {
    background-color: var(--color-white);
    transition: all .3s ease;
}

.base-tabs__content {
    padding: var(--measure-l);
}
</style>
